module.exports = {
  HOST: '',
  TABLE_SHRINK_HEIGHT: 0,
  DEFAULT_USER: '',
  DEFAULT_PASSWORD: '',
  VERSION: '28081128',
  VERSION_DATE: '28.08.2026'
}
